import { createContext } from 'react'

export type ContextType = {
    type: 'normal' | 'large'
    hover: boolean
}

export const Context = createContext<ContextType>({ type: 'normal', hover: true })
